import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function DeleteButton(props) {
    const { x = 'initial', y = 'initial', onDelete = () => null, fill = '#c81121', } = props;
    return (_jsxs("svg", { className: "delete-button", x: x, y: y, onClick: onDelete, "data-no-export": "true", children: [_jsx("rect", { rx: "5", width: "16", height: "16", fill: fill }), _jsx("line", { x1: "5", x2: "10", y1: "8", y2: "8", stroke: "white", strokeWidth: "2" })] }));
}
export default DeleteButton;
